export interface CompleterItem {
  title: string;
  description?: string;
  image?: string;
  originalObject: any;
};



// WEBPACK FOOTER //
// C:/ProactiView/ProactiView-Client/src/libs/mdbootstrap/typescripts/pro/autocomplete/components/completer-item.component.ts